import {fetchBody, URL_DEPARTMENT_GET_DEPARTMENT_LIST, URL_DEPARTMENT_ADD_DEPARTMENT, URL_DEPARTMENT_GET_DEPARTMENT_DETAIL, URL_DEPARTMENT_UPDATE_DEPARTMENT} from "../config"
import { toLogout, cleanFetch } from "./apiTools";
import { getToken } from "../component/Login/Auth";
import { async } from "q";


export function api_getDepartmentList ({mReqDepartmentList, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqDepartmentList, token}), 
      url: URL_DEPARTMENT_GET_DEPARTMENT_LIST, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}

export function api_addDepartment ({mReqDepartmentAdd, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqDepartmentAdd, token}), 
      url: URL_DEPARTMENT_ADD_DEPARTMENT, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}

export function api_getDepartmentDetail ({mReqDepartmentDetail, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqDepartmentDetail, token}), 
      url: URL_DEPARTMENT_GET_DEPARTMENT_DETAIL, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}

export function api_updateDepartment ({mReqUpdateDepartment, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqUpdateDepartment, token}), 
      url: URL_DEPARTMENT_UPDATE_DEPARTMENT, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}
